import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface EntityLinkProps {
  name: string;
  href: string;
  iconImagePath: string;
  iconHeightOverride?: number;
  textStyleOverride?: React.CSSProperties;
  iconStyle?: boolean;
  background?: boolean;
}

export function EntityLink(props: EntityLinkProps): JSX.Element {
  const entityLabelElement = props.href
    ? <TextLinkWidget href={props.href} style={props.textStyleOverride}>{props.name}</TextLinkWidget>
    : <span style={props.textStyleOverride}>{props.name}</span>;

  const iconHeight = props.iconHeightOverride || 17;
  // minHeight (not height) so the row grows to fit a wrapped long name instead of clipping and overlapping the row below.
  const iconStyle: React.CSSProperties = {
    minHeight: `${iconHeight}px`
  };

    /* eslint-disable jsx-a11y/alt-text */
  if(props.iconStyle){
    return (
      <div className={DetailsTooltipStyles.IconMetadataLinkValue} style={iconStyle}>
      {
        props.background &&
        <div className={DetailsTooltipStyles.cartoucheIconWithBackgroundClass}>
          <img src={props.iconImagePath} className={DetailsTooltipStyles.cartoucheIconImageWithBackgroundClass}/>
        </div>
      }
      {
        !props.background &&
        <div className={DetailsTooltipStyles.cartoucheIconWithoutBackgroundClass}>
          <img src={props.iconImagePath} className={DetailsTooltipStyles.cartoucheIconImageWithoutBackgroundClass}/>
        </div>
      }
      {entityLabelElement}
      </div>
    );
  }
  else{
    return (
      <div className={DetailsTooltipStyles.MetadataLinkValue} style={iconStyle}>
        <img src={props.iconImagePath} className={DetailsTooltipStyles.ContentTypeIcon}/>
        {entityLabelElement}
      </div>
    );
  }

}
